__turbopack_context__.v({
  "buttonGroup": "ShortcutCaptureInput-module__QKZkLq__buttonGroup",
  "clearedDash": "ShortcutCaptureInput-module__QKZkLq__clearedDash",
  "conflictField": "ShortcutCaptureInput-module__QKZkLq__conflictField",
  "container": "ShortcutCaptureInput-module__QKZkLq__container",
  "inlineFieldShell": "ShortcutCaptureInput-module__QKZkLq__inlineFieldShell",
  "outerWrapper": "ShortcutCaptureInput-module__QKZkLq__outerWrapper",
  "shortcutControl": "ShortcutCaptureInput-module__QKZkLq__shortcutControl",
  "trailingReset": "ShortcutCaptureInput-module__QKZkLq__trailingReset",
});
